module.exports = __webpack_public_path__ + "assets/img/LTC032.121fc49a.jpg";